import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "@phosphor-icons/react";
import { useLang } from "@/context/LanguageContext";
import { Reveal } from "@/components/Reveal";

export const FAQ = () => {
  const { t } = useLang();
  const [open, setOpen] = useState(0);

  return (
    <section data-testid="faq" className="relative bg-[#FAFAF7] py-24 md:py-36">
      <div className="max-w-[900px] mx-auto px-6 md:px-12">
        <Reveal className="mb-14">
          <p className="text-sm tracking-luxe uppercase text-[#A39B8E] mb-6">{t.faq.kicker}</p>
          <h2 className="font-display font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight">
            {t.faq.title}
          </h2>
        </Reveal>

        <div className="border-t border-black/10">
          {t.faq.items.map((it, i) => {
            const isOpen = open === i;
            return (
              <Reveal key={i} delay={i * 0.05} className="border-b border-black/10">
                <button
                  data-testid={`faq-item-${i}`}
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="w-full flex items-center justify-between gap-6 py-7 text-left group"
                >
                  <span className={`font-display text-xl md:text-2xl font-light transition-colors ${isOpen ? "text-[#8B7355]" : "text-[#1A1A1A] group-hover:text-[#8B7355]"}`}>
                    {it.q}
                  </span>
                  <motion.span animate={{ rotate: isOpen ? 45 : 0 }} transition={{ duration: 0.3 }} className="shrink-0">
                    <Plus size={24} weight="light" className="text-[#8B7355]" />
                  </motion.span>
                </button>
                <AnimatePresence initial={false}>
                  {isOpen && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
                      className="overflow-hidden"
                    >
                      <p className="pb-7 pr-10 text-[#1A1A1A]/65 leading-relaxed max-w-2xl">{it.a}</p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
